export default {
  // Application initialization
  INITIALIZE_SESSION: "INITIALIZE_SESSION",

  // Session
  CREATE_SESSION_SUCCESSFUL: "CREATE_SESSION_SUCCESSFUL",
  CREATE_SESSION_FETCHING: "CREATE_SESSION_FETCHING",
  CREATE_SESSION_FAILED: "CREATE_SESSION_FAILED",
  DELETE_SESSION_SUCCESSFUL: "DELETE_SESSION_SUCCESSFUL",
  REFRESH_SESSION_SUCCESSFUL: "REFRESH_SESSION_SUCCESSFUL",
  REFRESH_SESSION_FAILED: "REFRESH_SESSION_FAILED",
  SESSION_EXPIRED: "SESSION_EXPIRED",

  // Current user
  FETCH_CURRENT_USER_SUCCESSFUL: "FETCH_CURRENT_USER_SUCCESSFUL",
  FETCH_CURRENT_USER_FAILED: "FETCH_CURRENT_USER_FAILED",
};
